import "./ActorList.css";
import "../Common.css"

import { Container, Row, Col } from 'react-bootstrap';
import { useState } from "react";

//import arrayOfCharacters from './characters';
import { JsxElement } from "typescript";

type MatchProps = {
    id: string,
    character: string
}

type ResultProps = {
    credit: {
        cast: MatchProps[]
    }
};

type FilmEntry = {
    id: string,
    title: string,
    character: string
}

type Actor = {
    id: string,
    name: string,
    films: FilmEntry[]
}

type Props = {
    title:string, 
    matches: ActorRole[]
}

type ActorRole = {
    id:string,
    name:string,
    character:string,
    movies:MovieRole[]
}

type MovieRole = {
    title:string,
    character:string
}
  
const ActorList: React.FC<Props> = (input: Props) => {
    //const [matches, setMatches] = useState<MatchProps[]>([]);

    const rowEntry = (match:ActorRole):JSX.Element =>
    {
        console.log(match);
        return <tr>
            <th className="actorEntry">
                {match.name}
            </th>
            <th className="actorEntry">
                {match.character}
            </th>
            <th className="actorEntry">
                {
                    match.movies.map((movie:MovieRole)=><div>{movie.title} - {movie.character}</div>)
                }
            </th>
        </tr>
    }

    // const getMovieData = () => {
    //     const dataJ = fetch(`https://api.themoviedb.org/3/movie/${movieID}?api_key=4237307735295a0d8ffbe8672656f5ae&language=en-US&append_to_response=credits`).then((res) => res.json()).then((data)=>setMatches(data.credits.cast.filter((result:MatchProps) => {return arrayOfCharacters.hasOwnProperty(result.id)})));
    //     //const dataJ = await data.json(); // fetching data from API in JSON Format

    //     console.log(dataJ);
    //     // dataJ.results.map((result:ResultProps) => ({
    //     //     value: result.id,
    //     //     label: `${result.title} (${new Date(result.release_date).getFullYear()})`
    //     //     })
    //     // );
    //     //const matches:MatchProps[] = dataJ.credits.cast.filter((result:MatchProps) => {return arrayOfCharacters.hasOwnProperty(result.id)});
    //     console.log(matches);

    //     //return matches;//.map((match:MatchProps) => (rowEntry(match)));
    // }

    if(input.title === "")
    {
        return (
            <div />
        )
    }
    if(input.matches.length === 0)
    {
        return (
            <Col xs={{ span: 10, offset: 1 }}>
                <h1>Total MCU Actors: 0</h1>
            </Col>
        )
    }
    else
    {
        //getMovieData();
        return (
            <Col xs={{ span: 10, offset: 1 }}>
                <table className="actorTable">
                    <tr className="headerBar">
                        <th className="header">Actor</th>
                        <th className="header">Character</th>
                        <th className="header">MCU Characters</th>
                    </tr>
                    {
                        input.matches.map((match:ActorRole)=>(rowEntry(match)))
                    }
                    
                </table>

                <br />
                <h1>Total MCU Actors: {input.matches.length}</h1>
            </Col>
        )
    }
}

export default ActorList;